// Copyright ©️ 2026 eVolve MEP, LLC

import { TwoPanelLayout } from 'app/Layout/TwoPanelLayout';
import { AssemblyEditorView } from 'modules/Shop/CatalogSetup/PartEditor/AssemblyEditorView';
import { EditItemPane } from 'modules/Shop/CatalogSetup/PartEditor/EditItemPane';
import { AssemblyEditorProvider } from 'modules/Shop/CatalogSetup/PartEditor/useAssemblyEditor';
import { PartEditorProvider } from 'modules/Shop/CatalogSetup/PartEditor/usePartEditor';

export const PartEditorPage = () => (
  <PartEditorProvider>
    <AssemblyEditorProvider>
      <TwoPanelLayout mainPanel={<AssemblyEditorView />} detailPanel={<EditItemPane />} />
    </AssemblyEditorProvider>
  </PartEditorProvider>
);
